import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["xlink:href"];
import { computed } from 'vue';
export default {
  __name: 'index',
  props: {
    name: {
      type: String,
      default: '',
      required: true
    },
    size: {
      type: [Number, String],
      default: 16
    },
    width: {
      type: [Number, String],
      default: ''
    },
    height: {
      type: [Number, String],
      default: ''
    },
    fill: {
      type: String,
      default: 'currentColor'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var sizeStyle = computed(function () {
      var size = props.size,
        width = props.width,
        height = props.height;
      var w = "".concat(width);
      var h = "".concat(height);
      var s = "".concat(size);
      w = "".concat(w.replace('px', ''), "px");
      h = "".concat(h.replace('px', ''), "px");
      s = "".concat(s.replace('px', ''), "px");
      return {
        width: width || height ? w : s,
        height: width || height ? h : s,
        fill: props.fill
      };
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("svg", {
        "aria-hidden": "true",
        class: _normalizeClass(["svg-icon", ["svg-".concat(__props.name)]]),
        style: _normalizeStyle(sizeStyle.value)
      }, [_createElementVNode("use", {
        "xlink:href": "#".concat(__props.name)
      }, null, 8, _hoisted_1)], 6);
    };
  }
};